// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ant-modal-content .ant-modal-footer .ant-btn-primary.ant-btn[disabled=disabled]{background:rgba(227,29,51,.5)!important;color:#fff!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
